import { useAppStore } from '@/stores/app'
import { createRouter, createWebHistory } from 'vue-router'
import { routes } from './parts'
import { setupRouterGuards } from './config/beforeEach'
import { scrollBehavior } from './config/scrollBehavior'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior
})

router.beforeEach(setupRouterGuards)

router.afterEach((to, from) => {
  if (to.name !== 'home') return
  const prev = from?.name
  if (prev !== 'platform' && prev !== 'document') return
  useAppStore().updatePageId('')
})

export default router